<template>
    <div class="page-deliver-todo">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">集金幣管理</div>
            <div class="breadcrumb-item">集金幣設置</div>
        </div>
        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <Select size="small" placeholder="類型" v-model="form.type_id" clearable>
                        <Option :value="item.id" v-for="(item, index) in pickAddress"
                                :key="item.id">{{item.name}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                        <div class="pg-btn style2" @click="handleAdd">新增</div>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(index)">修改</div>
                        <!-- <div class="pg-btn style1" @click="handleDelete(index)">删除</div> -->
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="11" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="13" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>


    </div>
</template>

<script>
   import axios from 'axios';

   export default {
      data() {
         return {
            pageIndex: 1,   //页码
            curPageSize: 10,    //一页数量
            totalCount: 1, //总条数
            pageInput: '',  //输入的页码
            isSubmiting: false,
            pickAddress: [],
            form: {
               type_id: '',
            },
            table: {
               column: [
                  {
                     title: '更新時間',
                     key: 'updated_at',
                     align: 'center',
                     sortable: true,
                     minWidth: 120
                  },
                  {
                     title: '類型',
                     key: 'name',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '最低消費(區間)',
                     key: 'interval_smal',
                     align: 'center',
                     sortable: true,
                     minWidth: 130
                  },
                  {
                     title: '最高消費(區間)',
                     key: 'interval_max',
                     align: 'center',
                     sortable: true,
                     minWidth: 130
                  },
                  {
                     title: '上家獲得集金幣',
                     key: 'percentage_superior',
                     align: 'center',
                     sortable: true,
                     minWidth: 160
                  },
                  {
                     title: '下家獲得集金幣',
                     key: 'percentage_same',
                     align: 'center',
                     sortable: true,
                     minWidth: 160
                  },
                  {
                     title: '贈送集金幣有效天數',
                     key: 'the_term',
                     align: 'center',
                     sortable: true,
                     minWidth: 100
                  },
                  {
                     title: '備註',
                     key: 'remarks',
                     align: 'center',
                     sortable: true,
                     minWidth: 120
                  },
                  {
                     title: '狀態',
                     key: 'status',
                     align: 'center',
                     sortable: true,
                     minWidth: 120
                  },
                  {
                     title: '操作',
                     slot: 'action',
                     align: 'center',
                     minWidth: 100
                  }
               ],
               data: []
            }
         };
      },
      mounted() {
         this.getList();
         this.getPickAdmin();
      },
      activated()
      {
         this.getList();
         this.getPickAdmin();
      },
      methods: {
         getPickAdmin()
         {
          this.$Rq.requestAuth({
              url: this.$Api.jpointroleType,
              method: 'get'
          }).then((res) =>
          {
              if (res.code == 0)
              {
                  this.pickAddress = res.data.data;
              }
          });
         },
         formatDate(datetime) {
            if (!datetime) return '';

            let dateTime = new Date(datetime);
            let year = dateTime.getFullYear();
            let month = dateTime.getMonth() + 1;
            let date = dateTime.getDate();
            let hour = dateTime.getHours();
            let minute = dateTime.getMinutes();
            let second = dateTime.getSeconds();
            let milliseconds = dateTime.getMilliseconds();
            return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
         },
         formatNum(num) {
            return num < 10 ? '0' + num : num;
         },
         getList() {
            let form = this.form;
            this.isSubmiting = true;
            this.$Rq.requestAuth({
               url: this.$Api.jpointroleList,
               method: 'get',
               data: {
                  type_id: form.type_id,
               }
            }).then((res) => {
               this.isSubmiting = false;
               if (res.code == 1) {
                  let tempArr = [];
                  let resData = res.data.data;

                  for (let i = 0; i < resData.length; i++) {

                    if(resData[i].type_id == 2){
                      resData[i].interval_smal = 0;
                      resData[i].interval_max = '∞';
                      resData[i].percentage_same = resData[i].percentage_same + '%';
                      resData[i].percentage_superior = resData[i].percentage_superior + '%';
                    }

                     tempArr.push({

                        id: resData[i].id,

                        name: resData[i].name,

                        interval_smal: resData[i].interval_smal,

                        interval_max: resData[i].interval_max,

                        percentage_same: resData[i].percentage_same,

                        percentage_superior: resData[i].percentage_superior,

                        remarks: resData[i].remarks,

                        the_term: resData[i].the_term,

                        type: resData[i].type,

                        status: resData[i].status == 1 ? '啟用' : '關閉',

                        updated_at: resData[i].updated_at == null ? '- - -' : resData[i].updated_at

                     });
                  }

                  this.totalCount = res.data.count;
                  this.table.data = tempArr;
               }
            }).catch((err) => {
               this.isSubmiting = false;
            });
         },
         handleSearch() {
            this.pageIndex = 1;
            this.getList();
         },
         handleAdd() {
            this.$router.push({path: '/jpointSettingAdd'});
         },
         handleEdit(index) {
            let tabItemId = this.table.data[index].id;
            this.$router.push({path: '/jpointSettingEdit?id=' + tabItemId});
         },
         handleDelete(index) {
            this.$Modal.confirm({
               title: '提示',
               content: '確定刪除嗎？',
               cancelText: '取消',
               okText: '確定',
               onOk: () => {
                  let tableData = this.table.data;
                  this.isSubmiting = true;

                  this.$Rq.requestAuth({
                     url: this.$Api.deliverDelete + '/' + tableData[index].id,
                     method: 'delete'
                  }).then((res) => {
                     this.isSubmiting = false;

                     if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);

                        if (tableData.length <= 1 && this.pageIndex > 1) {
                           this.pageIndex -= 1;
                        }

                        this.getList();

                     } else {
                        this.$Utils.showTipInfo(res.msg);
                     }
                  }).catch((err) => {
                     this.isSubmiting = false;
                  });

               }
            });
         },
         handlePageSizeChange(value) {
            this.pageIndex = 1;
            this.getList();
         },
         handlePageInput() {
            let value = ('' + this.pageInput).replace(/\D/g, '');
            let pageCount = Math.ceil(this.totalCount / this.curPageSize);
            if (value > pageCount) {
               value = pageCount;
            }
            this.pageInput = value;
         },
         handlePageEnter() {
            if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
            if (this.pageInput == 0) {
               this.pageInput = 1;
            }
            this.pageInput = parseInt(this.pageInput);
            this.pageIndex = this.pageInput;
            this.getList();
         },
         handlePageChange(value) {
            this.pageIndex = value;
            this.getList();
         }
      }
   };
</script>

<style lang="scss" scoped>
    @import "jpointSetting.scss";
</style>